import type { HTMLAttributes } from 'react';

interface IconsProps extends HTMLAttributes<HTMLSpanElement> {
    /** Nom de l'icône de la police `icon-*` (`public/fonts`). */
    icon?: string;
    fontSize?: number;
}

const Icons = (props: IconsProps) => {
    const { icon = 'moto', className, fontSize, ...other } = props;

    return <span className={`icon-${icon} ${className}`} style={{ fontSize }} {...other} />;
};

export default Icons;
